<template lang="html">
  <header id="header">
    <div class="header-content">

      <!-- Header top -->
      <div class="header-top">
        <div class="container oversized-container">
          <div class="row align-items-center">
            <div class="col-sm col-info">
              <span class="aqual">Atención Empresas</span>
              <span class="f-w-500"><a :href="'tel:'+$root.extras.telefono">{{$root.extras.telefono}}</a></span>
              <span><span class="aqual link-sm" @click="openedModal = 'aviso'" style="cursor:pointer;">Aviso de privacidad</span></span>
              <span><span class="aqual link-sm" @click="openedModal = 'terminos'" style="cursor:pointer;">Terminos y condiciones</span></span>
            </div>

            <div class="col-sm col-networks">
              <span class="aqual">Síguenos</span>
              <span>
                <a class="link-network" :href="$root.extras.facebook" target="_blank"><i class="fab fa-facebook-f"></i></a>
               <!--  <a class="link-network" :href="$root.extras.twitter" target="_blank"><i class="fab fa-twitter"></i></a> -->
                <a class="link-network" :href="$root.extras.instagram" target="_blank"><i class="fab fa-instagram"></i></a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--  -->

      <!-- Header menu -->
      <div class="container oversized-container header-menu">
        <b-navbar toggleable="lg" type="light" variant="light">
          <b-navbar-brand to="/">
            <img src="public/images/logo.svg">
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"><i class="far fa-bars icon"></i></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
              <b-nav-item class="nav-sample" to="/empleos">Ver Empleos</b-nav-item>
              <b-nav-item class="nav-sample" to="/empresas">Empresas</b-nav-item>
              <!-- <b-nav-item class="nav-sample aqua" to="">Registro</b-nav-item> -->
              <li class="nav-item nav-sample aqua d-lg-none">
                <a class="nav-link"><hr class="my-1" /></a>
              </li>
              <li class="nav-item ml-lg-3 nav-sample aqua" v-if="$root.logged != true">
                <a class="nav-link" @click="openedModal = 'register'">Registro</a>
              </li>
              <li class="nav-item nav-sample aqua"  v-if="$root.logged != true">
                <a class="nav-link" @click="openedModal = 'loginuser'">Ingresar</a>
              </li>
              <li class="nav-item nav-sample aqua" v-else>
                <b-nav-item class="nav-sample" v-if="$root.type_logged == 'empresa'" to="/cuenta-empresa">Hola: <b>{{$root.user.name}}</b></b-nav-item>
                <b-nav-item class="nav-sample" v-else-if="$root.type_logged == 'usuario'" to="/cuenta-usuario">Hola: <b>{{$root.user.name}}</b></b-nav-item>
              </li>

              <li class="nav-item nav-sample aqua d-lg-none" v-if="$root.type_logged == 'empresa'">
                <b-nav-item class="nav-sample" :to="{ name: 'compAccPlans' }">
                  <strong class="txt-aqua2">Plan Básico</strong>
                  <a class="ml-5 small f-w-700 txt-graydark"><i class="fal fa-edit mr-1"></i>Cambiar plan</a>
                </b-nav-item>
              </li>

              <li class="nav-item nav-sample d-none d-lg-block" v-if="$root.logged == true">
                <a class="nav-link" @click="logout">Cerrar sesion</a>
              </li>

              <!-- Usuario logeado -->
                <!-- <b-nav-item class="nav-sample aqua" to="/usuario">Mi cuenta</b-nav-item> -->

                <!-- Empresa -->
                <div class="d-lg-none" v-if="$root.type_logged == 'empresa'">
                  <li class="nav-item nav-sample aqua">
                    <a class="nav-link"><hr class="my-1" /></a>
                  </li>
                  <b-nav-item class="nav-sample nav-wicon nav-panel aqua" :to="{ name: 'compAccIndex' }">Perfil de empresa</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-bannr aqua" :to="{ name: 'compAccImageLogo' }">Logo de perfil</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-bannr aqua" :to="{ name: 'compAccBanner' }">Imagen de cabecera</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-prfle aqua" :to="{ name: 'compAccProfile' }">Perfil de Empresa</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-plan aqua" :to="{ name: 'compAccPlans' }">Planes</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-pvacn aqua" :to="{ name: 'compAccPostVacancy' }">Publicar Vacante</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-evacn aqua" :to="{ name: 'compAccEditVacancies' }">Editar vacante</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-candi aqua" :to="{ name: 'compAccCandidates' }">Candidatos que aplicaron</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-candi aqua" :to="{ name: 'AllCandidates' }">Todos los candidatos</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-sprof aqua" :to="{ name: 'compAccSavedProfiles' }">Perfiles guardados</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-score aqua" :to="{ name: 'compAccComments' }">Calificaciones</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-msges aqua" :to="{ name: 'compAccMessages' }">Mensajes</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-secty aqua" :to="{ name: 'compAccSecurity' }">Seguridad</b-nav-item>

                  <li class="nav-item nav-sample aqua">
                    <a class="nav-link"><hr class="my-1" /></a>
                  </li>
                  <li class="nav-item nav-sample text-center red">
                    <span class="nav-link f-w-700" @click="logout">SALIR</span>
                  </li>
                </div>
                <!--  -->

                <!-- Usuario -->
                <div class="d-lg-none" v-else-if="$root.type_logged == 'usuario'">
                  <li class="nav-item nav-sample aqua">
                    <p class="mb-2">
                    <a class="btn-squ-cur-1 blue-s2 lg" @click="downloadcv()" style="font-size: 12px;">Descargar CV</a>
                  </p>
                  </li>
                  <b-nav-item class="nav-sample nav-wicon nav-panel aqua" :to="{ name: 'userAccIndex' }">Mi Panel</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-bannr aqua" :to="{ name: 'userAccImagePhoto' }">Foto de perfil</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-bannr aqua" :to="{ name: 'userAccBanner' }">Imagen de cabecera</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-prfle aqua" :to="{ name: 'userAccProfile' }">Editar Perfil</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-currm aqua" :to="{ name: 'userAccCV' }">Mi Curriculum</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-vapli aqua" :to="{ name: 'userAccAppliedVacancies' }">Vacantes Aplicadas</b-nav-item>
                  <!-- <b-nav-item class="nav-sample nav-wicon nav-alrts aqua" to="/cuenta-usuario">Alertas Creadas</b-nav-item> -->
                  <b-nav-item class="nav-sample nav-wicon nav-score aqua" :to="{ name: 'userAccComments' }">Mi calificacion</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-score-2 aqua" :to="{ name: 'userAccCommentstocompanies' }">Calificaciones a empresas</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-favorites aqua" :to="{ name: 'userVacants' }">Favoritos</b-nav-item>

                  <b-nav-item class="nav-sample nav-wicon nav-msges aqua" :to="{ name: 'userAccMessages' }">Mensajes</b-nav-item>
                  <b-nav-item class="nav-sample nav-wicon nav-secty aqua" :to="{ name: 'userAccSecurity' }">Seguridad</b-nav-item>

                  <li class="nav-item nav-sample aqua">
                    <a class="nav-link"><hr class="my-1" /></a>
                  </li>
                  <li class="nav-item nav-sample text-center red">
                    <span class="nav-link f-w-700" @click="logout">SALIR</span>
                  </li>
                </div>
                <!--  -->
              <!--  -->

              <b-nav-item class="ml-lg-2 d-none d-lg-block nav-btn" to="/cuenta-empresa/publicar-vacante" v-if="$root.type_logged == 'empresa'">Publicar Vacante</b-nav-item>
              <b-nav-item class="ml-lg-2 d-none d-lg-block nav-btn" v-else-if="$root.logged == null"  @click="openedModal = 'loginemployer'">Publicar Vacante</b-nav-item>


            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
      <!--  -->

      <!-- Header search form -->
      <div class="header-search-form" v-if="$route.name == 'homePage'">
        <div class="container oversized-container content">
          <search-form-component></search-form-component>
        </div>
      </div>
      <!--  -->

      <!-- Empty section -->
      <div class="header-space" v-else></div>
      <!--  -->

    </div>

    <!-- Modal register -->
    <modalregister-component></modalregister-component>
    <!--  -->

    <!-- Modal login -->
    <modallogin-component></modallogin-component>
    <!--  -->

    <!-- Modal reset password -->
    <modalresetpass-component></modalresetpass-component>
    <!--  -->

    <!-- Modal aviso de privacidad-->
    <modalaviso-component></modalaviso-component>
    <!--  -->

    <!-- Modal terminos-->
        <modalterminos-component></modalterminos-component>
        <!--  -->

  </header>
</template>

<script>
import modalloginComponent from './modals/modal-login.vue';
import modalregisterComponent from './modals/modal-register.vue';
import modalresetpassComponent from './modals/modal-reset-password.vue';
import searchFormComponent from './search-form-component.vue';
import modalavisoComponent from './modals/modal-aviso-privacy.vue';
import modalterminosComponent  from './modals/modal-terminos.vue';


export default {
  data(){
    return{
      openedModal: null,
    }
  },

  methods:{
      logout(){
        axios.post(tools.url("/logout")).then((response)=>{
            this.$root.user = {};
            this.$root.logged=null;
            this.$root.type_logged='';
            this.$router.push('/');
            location.reload();
          }).catch(()=>{});
      },
      downloadcv(){
          axios.get(tools.url("/downloadCvPostulate/"+this.$root.user.usercompany.id)).then((response)=>{
              console.log(response);
              window.open(response.data,'_blank');
          }).catch(()=>{});
      }
  },

  components: {
    modalloginComponent, modalregisterComponent, modalresetpassComponent, searchFormComponent,modalavisoComponent,modalterminosComponent
  },

  mounted(){}
}
</script>
